import { parseCloudRun } from './parseCloud'
import type {
  CastRoadmapVoteResult,
  GetProductUpdatesResult,
  ProductUpdatesPayload,
  RevokeRoadmapVoteResult,
  SaveProductUpdatesResult,
} from '../../../types/ProductUpdates'

// Through the shared wrapper, not `Parse.Cloud.run`: a call refused because another tab replaced
// the session is sent again on the newer token, and a really ended session signs out like any other.
export async function fetchProductUpdates(): Promise<GetProductUpdatesResult> {
  const res = await parseCloudRun<Partial<GetProductUpdatesResult>>('getProductUpdates', {})
  const emptyVote = { countsByItemId: {} as Record<string, number>, votedItemIds: [] as string[] }
  return {
    success: res.success !== false,
    payload: res.payload ?? {
      schemaVersion: 2,
      releases: [],
      roadmap: [],
      voteCampaigns: [],
    },
    updatedAt: res.updatedAt ?? null,
    payloadVersion: res.payloadVersion ?? 0,
    hasActiveVoting: res.hasActiveVoting === true,
    voteState: res.voteState ?? emptyVote,
  }
}

export async function saveProductUpdates(
  payload: ProductUpdatesPayload,
  expectedPayloadVersion?: number | null
): Promise<SaveProductUpdatesResult> {
  const params: Record<string, unknown> = { payload }
  if (expectedPayloadVersion !== undefined && expectedPayloadVersion !== null) {
    params.expectedPayloadVersion = expectedPayloadVersion
  }
  return parseCloudRun<SaveProductUpdatesResult>('saveProductUpdates', params)
}

export async function castRoadmapVote(roadmapItemId: string): Promise<CastRoadmapVoteResult> {
  return parseCloudRun<CastRoadmapVoteResult>('castRoadmapVote', { roadmapItemId })
}

export async function revokeRoadmapVote(roadmapItemId: string): Promise<RevokeRoadmapVoteResult> {
  return parseCloudRun<RevokeRoadmapVoteResult>('revokeRoadmapVote', { roadmapItemId })
}
